export default "__VITE_ASSET__d6fa0dcb__"